import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquare } from "lucide-react";
import { api } from "@/lib/api";

export default function MessagesBell() {
  const [unread, setUnread] = useState(0);

  const load = async () => {
    try {
      const { data } = await api.get("/messages/unread-count");
      setUnread(data.unread || 0);
    } catch { /* ignore */ }
  };

  useEffect(() => {
    load();
    const id = setInterval(load, 8000);
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => { clearInterval(id); window.removeEventListener("focus", onFocus); };
  }, []);

  return (
    <Link
      to="/messages"
      className="relative w-9 h-9 rounded-full bg-white border border-slate-200 hover:border-orange-300 flex items-center justify-center transition-colors"
      aria-label="Messages"
      data-testid="messages-bell"
    >
      <MessageSquare size={18} className="text-slate-700" />
      {unread > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-orange-500 text-white text-[10px] font-bold flex items-center justify-center" data-testid="messages-unread-badge">
          {unread}
        </span>
      )}
    </Link>
  );
}
